var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 48.125H51.5625V51.5625H3.4375V48.125ZM46.4062 18.9062C46.8621 18.9062 47.2993 18.7251 47.6216 18.4028C47.9439 18.0805 48.125 17.6433 48.125 17.1875V12.0312C48.1249 11.678 48.0159 11.3334 47.8129 11.0443C47.6099 10.7552 47.3228 10.5357 46.9906 10.4156L28.0844 3.5406C27.7068 3.40407 27.2932 3.40407 26.9156 3.5406L8.00937 10.4156C7.67719 10.5357 7.39008 10.7552 7.1871 11.0443C6.98413 11.3334 6.87515 11.678 6.875 12.0312V17.1875C6.875 17.6433 7.05608 18.0805 7.37841 18.4028C7.70074 18.7251 8.13791 18.9062 8.59375 18.9062H10.3125V41.25H6.875V44.6875H48.125V41.25H44.6875V18.9062H46.4062ZM10.3125 13.2343L27.5 6.9781L44.6875 13.2343V15.4687H10.3125V13.2343ZM30.9375 41.25H24.0625V18.9062H30.9375V41.25ZM13.75 18.9062H20.625V41.25H13.75V18.9062ZM41.25 41.25H34.375V18.9062H41.25V41.25Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceWhite);
export default __webpack_public_path__ + "static/media/financeWhite.27f13aaba6948ee1a4bb2e6ecaf749f0.svg";
export { ForwardRef as ReactComponent };